import { MeasurementSystem } from '@warebee/frontend/data-access-api-graphql';
import { CreateWarehouseInput } from '@warebee/shared/data-access-api-dto';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { NoMatch404 } from '../../NoMatch404';
import { WAREHOUSE_NEW_ID } from '../../common/constants';
import { ScreenTitle } from '../../components/layout/ScreenTitle';
import TitleSection from '../../components/layout/TitleSection';
import SettingsInviteUsers from '../../screens/settings/settings/SettingsInviteUsers';
import { warehouseList } from '../../store/warehouse.state';

export type WarehouseSettingsParams = {
  warehouseId: string;
};

const WarehouseSettingsPermissions: React.FC = () => {
  const { t } = useTranslation('app');

  const { warehouseId = WAREHOUSE_NEW_ID } =
    useParams<WarehouseSettingsParams>();
  const [whList, setWhList] = useRecoilState(warehouseList);

  const navigate = useNavigate();
  const defaultInputData: CreateWarehouseInput = {
    title: '',
    address: '',
    companyName: '',
    description: '',
    measurementSystem: MeasurementSystem.METRIC,
    country: 'GB',
    currency: 'GBP',
  };
  const isNewWarehouseSetup =
    warehouseId?.toLowerCase() === WAREHOUSE_NEW_ID.toLowerCase();
  const wh = _.find(whList, wh => wh.id === warehouseId);
  const [inputData, setInputData] = useState<CreateWarehouseInput>(
    isNewWarehouseSetup ? defaultInputData : wh,
  );

  useEffect(() => {
    const wh = _.find(whList, wh => wh.id === warehouseId);
    if (!_.isNil(wh)) {
      setInputData(_.cloneDeep(wh));
    }
  }, [whList]);

  if (!isNewWarehouseSetup && _.isNil(wh)) {
    return <NoMatch404 title={t`Warehouse not found`} />;
  }

  return (
    <>
      <ScreenTitle
        hasPadding
        isHero
        title={t`Warehouse Permissions`}
        subtitle={inputData?.title ?? t`Settings`}
        isSticky
      />

      <TitleSection title={t`Invite Users`} />

      <SettingsInviteUsers />
    </>
  );
};

export default WarehouseSettingsPermissions;
